export enum IncentiveType {
	SCHOLARSHIP_UPDATES = 'ScholarshipUpdates',
	EXPERIMENT = 'Experiment'
}
